import React from 'react';

import { ListWithTitle } from '../components/ListWithTitle';
import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const SubscriptionOfMaterials = () => {
  return (
    <>
      <Subtitle>
        Subscription of Newsletter/Promotional Materials/Marketing Materials
      </Subtitle>
      <ListWithTitle
        title={
          <>
            Glints and its affiliates may from time to time send to members and
            Users of the Site newsletters, information on job openings, and
            marketing materials based on the personal information and data that
            they have provided to Glints. Glints may use your data in direct
            marketing and Glints requires your consent (which includes an
            indication of no objection) for that purpose. In this connection,
            please note that:
          </>
        }
        list={[
          <>
            your name, login ID and password, contact details, age, gender, date
            of birth, country of residence, nationality, education level and
            work experience from time to time may be used by Glints and/or its
            authorized personnel or staff in direct marketing;
          </>,
          <>
            the following classes of services, products and subjects may be
            marketed:
            <br />- job-hunting and agencies services offered other than by
            Glints
            <br />- various courses, programs and career opportunities;
            <br />- special events hosted by Glints, including but not limited
            to courses, workshops, and competitions;
            <br />- reward, loyalty or privilege programs and related products
            and services;
            <br />- special offers including coupons, discounts, group purchase
            offers and promotional campaigns;
            <br />- products and services offered by Glints’ affiliates and
            advertisers (the names of such affiliates and advertisers can be
            found in the application form(s) for the relevant products and
            services, as the case may be);
            <br />- donations and contributions for charitable and/or non-profit
            making purposes;
          </>,
          <>
            the above products, services and subjects may be provided or (in the
            case of donations and contributions) solicited by Glints and/or;
            <br />- Glints’ affiliates;
            <br />- third party service providers providing the products,
            services and subjects listed in paragraph (b) above; and
            <br />- charitable or non-profit making organizations;
          </>,
          <>
            in addition to marketing the above services, products, and subject
            itself, Glints also intends to provide the data described in
            paragraph (a) above to all or any of the persons described in
            paragraph (c) above for use by them in marketing those services,
            products and subjects, and Glints requires your written consent
            (which includes an indication of no objection) for that purpose; and
          </>,
          <>
            Glints may receive money or other property in return for providing
            the data to the other persons in paragraph (d) above and, when
            requesting your written consent as described in paragraph (d) above,
            Glints will inform you if Glints receives any money or other
            property in return for providing the data to other persons.
          </>,
        ]}
      />
      <Paragraph>
        In this regard, you may choose to sign up or unsubscribe for such
        materials by logging into the registration or Settings page, or clicking
        on the automatic link appearing in each newsletter/message or contacting
        Glints using the contact details under the section headed “Enquiries“.
      </Paragraph>
    </>
  );
};
